import { useCallback, useState } from 'react'
import { toast } from 'react-toastify'

import { axiosInstance } from '../helpers'
import {
    PropertyInspectionComplete,
    TenantInspectionHubResponse,
} from '../types/inspection'

export const useInspectionHub = (
    leaseId: number | null | undefined,
    apartmentId: number | null | undefined,
) => {
    const [isLoading, setIsLoading] = useState(false)
    const [hubData, setHubData] = useState<TenantInspectionHubResponse | null>(
        null,
    )
    const [error, setError] = useState<string | null>(null)

    const getInspectionHub = useCallback(async () => {
        if (leaseId == null || apartmentId == null) {
            setHubData(null)
            setError(null)
            return null
        }
        setIsLoading(true)
        setError(null)
        try {
            const res = await axiosInstance.get<TenantInspectionHubResponse>(
                'inspection/tenant-inspection-hub/',
                { params: { lease_id: leaseId, apartment_id: apartmentId } },
            )
            setHubData(res.data)
            setIsLoading(false)
            return res.data
        } catch (e) {
            // toast.error('Error loading inspections')
            // setError('Error loading inspections')
            setIsLoading(false)
            return Promise.reject(e)
        }
    }, [leaseId, apartmentId])

    const getPropertyInspectionComplete = useCallback(
        (inspectionId: number): PropertyInspectionComplete | undefined => {
            return hubData?.property_inspections.complete.find(
                (entry) => entry.inspection_id === inspectionId,
            )
        },
        [hubData],
    )

    return {
        hubData,
        isLoading,
        error,
        getInspectionHub,
        getPropertyInspectionComplete,
    }
}
